(function () {

    'use strict';

    angular.module('Services').factory('aborter', aborter);

    function aborter($timeout) {
        let timer = null;
        return function (callback, timerDelay) {
            if (timer) {
                $timeout.cancel(timer);
                timer = null;
            }
            timer = $timeout(()=>{
                callback();
            },timerDelay || 1000);
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/Factories/aborter.js